
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
  
const API = {
  ADD: `project`,
  GET_ALL: `project`,
  DELETE: `project`,
  UPDATE: `project`,

  GET_ALL_IMAGE: `project_image`,

  ADD_IMAGE: `project_image`,
  DELETE_IMAGE: `project_image`,
  UPDATE_IMAGE: `project_image`,

};
const KEY = "project"


export const useGetProject = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneProject = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddProject = () => useAddMutation(KEY, API.ADD);
export const useUpdateProject = () => useUpdateMutation(KEY, API.UPDATE,true);

export const useDeleteProject = () =>useDeleteMutation(KEY, API.DELETE);

export const useGetProjectImage = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL_IMAGE,params);

export const useAddProjectImage = () => useAddMutation(KEY, API.ADD_IMAGE);

export const useDeleteProjectImage = () =>useDeleteMutation(KEY, API.DELETE_IMAGE);
